// Resolve any image URL to be reachable from the frontend origin.
//
// The backend may return either absolute URLs (new uploads, when
// BACKEND_PUBLIC_URL is configured) or path-relative URLs like
// "/api/assets/xxx.jpg". If the frontend is hosted on a different origin
// than the backend (e.g. rsbhayangkaratarakan.id vs admin.rsbhayangkaratarakan.id),
// path-relative URLs would 404 because they'd be resolved against the
// frontend origin. This helper prefixes them with REACT_APP_BACKEND_URL.
export const resolveImageUrl = (url) => {
  if (!url) return "";
  const s = String(url).trim();
  if (!s) return "";
  if (s.startsWith("data:") || s.startsWith("blob:")) return s;
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("//")) return s; // protocol-relative
  if (s.startsWith("/api/")) {
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    return `${base}${s}`;
  }
  return s;
};

export default resolveImageUrl;
